import { render, staticRenderFns } from "./roundTagRow.vue?vue&type=template&id=65c6ebb4&scoped=true&"
import script from "./roundTagRow.vue?vue&type=script&lang=js&"
export * from "./roundTagRow.vue?vue&type=script&lang=js&"
import style0 from "./roundTagRow.vue?vue&type=style&index=0&id=65c6ebb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6ebb4",
  null
  
)

export default component.exports